<div [ngClass]="isFranchisee?'card1Franchisee':'card1'">
  <div class="row breadcrumb">
    <div class="col-md-4 col-sm-4 col-4">
      <span class="b-left" (click)="back()">
        <mat-icon>keyboard_arrow_left</mat-icon>
        <span>Daily Log</span>
      </span>
    </div>
    <div class="col-md-4 col-sm-4 col-12">
      <h4 class="heading1">Daily Log Creation</h4>
    </div>
  </div>
  <div class="bids-container">
    <div class="row">
      <div class="col-md-6 col-sm-6 col-12">
        <div class="b-address">
          <!-- <mat-icon> location_on</mat-icon> -->
          <!-- <span>{{ projectDetail?.project_address }} </span> -->
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-12">
        <div class="b-name">
          <!-- <mat-icon>account_circle</mat-icon> -->
          <!-- <span>{{ projectDetail?.name }}</span> -->
        </div>
      </div>
    </div>
    <!-- <div class="weather">
            <div class="row">
                <div class="col-md-4 col-sm-4 col-4 pe-0 ps-1">
                    <div class="w-left pt-2">
                    <span class="bold">New York</span>
                    <span>Weather</span>
                    </div>
                </div>
                <div class="col-md-4 col-sm-4 col-4 ps-2 pe-2">
                    <div class="w-icon">
                        <mat-icon>cloud_queue</mat-icon>
                    </div>
                </div>
                <div class="col-md-4 col-sm-4 col-4 ps-0 pe-1">
                    <div class="w-right pt-2">
                        <span class="bold">27&#8451;</span>
                        <span>Overcast clouds</span>
                    </div>
                </div>
            </div>
        </div> -->
    <form [formGroup]="formDailyLog" (submit)="saveFormDailyLog()">
      <div class="row mt-3">
        
      <div class="col-md-12">
        <mat-form-field
          class="example-form-field full-width"
          appearance="outline"
        >
          <mat-label>Log Title</mat-label>
          <input matInput type="text" formControlName="log_title" required autocomplete="off" maxlength="200" #logtitleInput/>
          <mat-error *ngIf="formDailyLog.get('log_title').hasError('required')"
            >Log Title is required</mat-error
          >
        </mat-form-field>
        <div class="max-char">
          <p>Max-char : {{ formDailyLog?.get('log_title')?.value?.length || 0 }}/200</p>
        </div>
      </div>
      <div class="col-md-12">
        <mat-form-field
          class="example-form-field full-width"
          appearance="outline"
        >
          <mat-label>Log Detail</mat-label>
          <textarea
            matInput
            formControlName="log_description"
            maxlength="1000" #logdetailInput
          ></textarea>
          <!-- <mat-error
            *ngIf="formDailyLog.get('log_description').hasError('required')"
            >Description is required</mat-error
          > -->
        </mat-form-field>
        <div class="max-char">
          <p>Max-char : {{ formDailyLog?.get('log_description')?.value?.length || 0 }}/1000</p>
        </div>
      </div>
      <div class="mt-3 col-md-12">
        <mat-checkbox formControlName="date_related_exists">This log relates to a previous date</mat-checkbox>
    </div>
    <div class="mt-3 col-md-4" *ngIf="formDailyLog?.value?.date_related_exists">
      <mat-form-field appearance="fill" class="custom-datepicker">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" [max]="today" formControlName="date_related">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <p class="mb-2 font500">What was the weather that day ?</p>
          <div class="image-div">
            <div *ngFor="let icon of weather_icons;let i=index" class="img-label-container">
              <img  [src]="getIconUrl(icon?.icon)" [alt]="icon?.weather" [matTooltip]="icon?.weather" class="icon-img mb-1" (click)="selectWeather(icon,i)" [ngClass]="selectedWeatherIndex===i?'active':''">
              <p class="mb-0 fontItalic" *ngIf="selectedWeatherIndex===i">{{selectedWeather || ''}}</p>
            </div>
          </div>
        <!-- <mat-checkbox formControlName="date_related_exists">This log relates to a previous date</mat-checkbox> -->
    </div>
      </div>
      <!-- <div class="row">
            <div class="col-md-12">
                <div class="uploadFile">
                    <span class="pe-2">
                        <mat-icon>picture_as_pdf</mat-icon>
                    </span>
                    <span>filename.pdf</span>
                    <span class="end ps-2">
                        <mat-icon>cloud_download</mat-icon>
                    </span>
                </div>
            </div>
        </div> -->

        <div class="dl-detail mt-3">
          <div
            class="row"
            *ngFor="
              let file of formDailyLog?.value.daily_log_uploads;
              let i = index
            "
          >
            <div class="col-md-2 col-sm-3 col-6">
              <div class="dl-images">
                <img alt="" src="{{ file.file_path }}" />
                <!-- <mat-icon>get_app</mat-icon> -->
                <mat-icon class="close" (click)="removeFile(i, 'image',file)"
                  >close</mat-icon
                >
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="mt-2">
          <div class="bd-files">
            <div
              class="row"
              *ngFor="
                let file1 of formDailyLog?.controls?.daily_log_uploads_document?.value;let i = index"
            >
              <div class="col-md">
                <div class="bd-file">
                  <mat-icon *ngIf="file1?.file_path?.includes('.pdf')"
                    >picture_as_pdf</mat-icon
                  >
                  <mat-icon *ngIf="file1?.file_path?.includes('.jpg' || '.png')"
                    >image</mat-icon
                  >
                  <mat-icon *ngIf="file1?.file_path?.includes('.mp4')"
                    >video_library</mat-icon
                  >
                  <div class="file-name">
                    <span>{{ file1?.fileName }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-auto text-end">
                <a href="javascript:void(0)"
                class="mr-2"
              >
                <mat-icon (click)="downloadFile(file1)">download</mat-icon>
              </a>
              <a href="javascript:void(0)"
                (click)="removeFile(i, 'document',file1)"
              >
              <mat-icon>close</mat-icon>
            </a>
          </div>
            </div>
          </div>
        </div> -->
  
        <div class="mt-2">
          <div class="bd-files">
            <div
              class="row"
              *ngFor="
                let file1 of formDailyLog.controls['daily_log_uploads_document']?.value;
                let i = index
              "
            >
              <div class="col-md">
                <mat-chip class="bd-file">
                  <mat-icon *ngIf="file1?.file_path?.includes('.pdf')">picture_as_pdf</mat-icon>
                  <mat-icon *ngIf="file1?.file_path?.includes('.jpg') || file1?.file_path?.includes('.png')">image</mat-icon>
                  <mat-icon *ngIf="file1?.file_path?.includes('.mp4')">video_library</mat-icon>
                  <div class="file-name">
                    <span>{{ file1?.fileName }}</span>
                  </div>
                  <div class="icon-container">
                    <a href="javascript:void(0)" class="icon-button">
                      <mat-icon (click)="downloadFile(file1)">download</mat-icon>
                    </a>
                    <a href="javascript:void(0)" class="icon-button" (click)="removeFile(i, 'document', file1)">
                      <mat-icon>close</mat-icon>
                    </a>
                  </div>
                </mat-chip>
              </div>
            </div>
          </div>
        </div>
        <div class="actn-btns mt-3">
                    <input
                      type="file"
                      id=""
                      #fileInput
                      name="myfile"
                      (change)="onFileChange($event)"
                      class="custom-upload" multiple
                    />
                <button mat-raised-button type="button" color="primary" class="savebtn mr-1" (click)="openCaptureDialog()">
                  Capture
                </button>
                <button mat-stroked-button type="button" color="primary" (click)="fileInput.click()" class="documentbtn mr-1">
                    Upload Document
                </button>
                <button mat-raised-button type="submit" color="primary" class="savebtn">
                    Save Log
                </button>
        </div>
    


      <!-- <div class="text-end mt-3">
        <div class="">
          <input
            type="file"
            id=""
            #fileInput
            name="myfile"
            (change)="onFileChange($event)"
            class="custom-upload"
            [accept]="['.jpg', 'jpeg', '.png', '.pdf', '.doc', '.docx']"
          />
          <input type="file" id="" #fileInput2 name="myfile" 
                 (change)="onFileChange($event,'image')"  class="custom-upload" >
          <button
            mat-stroked-button
            type="button"
            color="primary"
            (click)="fileInput.click()"
            class="documentbtn me-1"
          >
            Upload Document
          </button>
          <button mat-stroked-button type="button" color="primary" (click)="fileInput2.click()" class="photobtn me-1"> Add Photo </button>
          </div>
            <div class="mt-2">
          <button
            mat-raised-button
            type="submit"
            color="primary"
            class="savebtn me-1"
          >
            Save Log
          </button>
        </div>
      </div> -->
    </form>
  </div>
</div>
